module.exports = __webpack_public_path__ + "static/media/member-check-in-white.2dde034c.svg";